import { RefObject, useEffect, useRef } from 'react';

const useAutofocus = ({
    delay,
}: { delay?: number } = {}): RefObject<HTMLInputElement> => {
    // Autofocus input
    const inputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        const input = inputRef.current;
        let timeout: NodeJS.Timeout;
        if (input) {
            if (delay) {
                timeout = setTimeout(() => input.focus?.(), delay);
            } else {
                input.focus?.();
            }
        }
        return () => {
            if (timeout) clearTimeout(timeout);
        };
    }, [inputRef, delay]);
    return inputRef;
};

export default useAutofocus;
